import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { ArrowRight, Grid, Zap } from 'lucide-react';
import BurrowLogo from './BurrowLogo';
import styles from './Navbar.module.css';

const NAV_LINKS = [
  { label: 'How it works', href: '#how' },
  { label: 'Services', href: '#services' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'FAQ', href: '#faq' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href) => {
    setMenuOpen(false);

    if (location.pathname !== '/') {
      navigate('/' + href);
      setTimeout(() => {
        const target = document.querySelector(href);
        if (target) {
          const offset = 80;
          window.scrollTo({ top: target.offsetTop - offset, behavior: 'smooth' });
        }
      }, 100);
      return;
    }

    const target = document.querySelector(href);
    if (target) {
      const offset = 80;
      window.scrollTo({ top: target.offsetTop - offset, behavior: 'smooth' });
    }
  };

  return (
    <>
      <nav className={`${styles.nav} ${scrolled ? styles.scrolled : ''}`}>
        <div className={styles.inner}>
          <Link to="/" className={styles.logo}>
            <BurrowLogo height={28} />
          </Link>

          <ul className={styles.navLinks}>
            {NAV_LINKS.map((link) => (
              <li key={link.href}>
                <button
                  className={styles.navLink}
                  onClick={() => handleNavClick(link.href)}
                >
                  {link.label}
                </button>
              </li>
            ))}
          </ul>

          <div className={styles.navCta}>
            <div className={styles.desktopBtns}>
              <button
                className="btn btn-ghost"
                onClick={() => handleNavClick('#pricing')}
              >
                See plans
              </button>
              <button
                className="btn btn-primary"
                onClick={() => handleNavClick('#pricing')}
              >
                Get started
              </button>
            </div>
            
            <button 
              className={styles.mobilePillBtn}
              onClick={() => handleNavClick('#pricing')}
              aria-label="See plans and get started"
            >
              <span className={styles.pillLeft}>See plans</span>
              <span className={styles.pillRight}>
                <ArrowRight size={16} />
              </span>
            </button>
          </div>

          <button
            className={styles.hamburger}
            aria-label="Toggle menu"
            onClick={() => setMenuOpen((o) => !o)}
          >
            <span className={menuOpen ? styles.open : ''} />
            <span className={menuOpen ? styles.open : ''} />
            <span className={menuOpen ? styles.open : ''} />
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`${styles.mobileMenu} ${menuOpen ? styles.mobileOpen : ''}`}>
        {NAV_LINKS.map((link) => (
          <button
            key={link.href}
            className={styles.mobileLink}
            onClick={() => handleNavClick(link.href)}
          >
            {link.label}
          </button>
        ))}
        <button
          className="btn btn-primary"
          style={{ marginTop: 8, width: '100%', justifyContent: 'center' }}
          onClick={() => handleNavClick('#pricing')}
        >
          Get started <ArrowRight size={18} style={{ marginLeft: 8 }} />
        </button>
      </div>
    </>
  );
}
